import { MultiselectCommand } from '../../core/model/command';
import { RentalObjectCategory } from '../model/const/enums';

export const buildingCommand = {
  linkDocument: 'linkDocument',
  showDocuments: 'showDocuments',
  moveToProperty: 'moveToProperty',
  export: 'export',
};
